module.exports = __webpack_public_path__ + "img/validation.c9bbac1c.png";